export const POS = {
  preview: {
    nameTop: 234,
    courseTop: 319,
    idTop:89,
    idRight: 70,
    idTopLong: 72,
    idRightLong: 49,
    qrTop: 459,
    qrRight: 380,
    qrWidth: 90,
    qrHeight: 85,
  },
  pdf: {
    nameY: 267,
    courseBaseY: 346,
    courseGapPx: 26,
    dateX: 84,
    dateY: 520,
    idXRight: 70,
    idY: 89,
    idXRightLong: 49,
    idYLong: 90,
    idFontPx: 14,
    idFontPxLong: 14,
    qrXRight: 0,
    qrY: 0,
    qrW: 0,
    qrH: 0,
  },
};
